import { useState, useCallback } from 'react';

/**
 * Hook for toggling password field visibility.
 * Returns state and helpers to use with a MUI TextField InputAdornment eye icon.
 *
 * Regression fix for #1020 / #1011.
 */
export function usePasswordVisibility() {
  const [showPassword, setShowPassword] = useState(false);

  const toggleVisibility = useCallback(() => setShowPassword((prev) => !prev), []);

  return {
    showPassword,
    inputType: showPassword ? 'text' : 'password',
    toggleVisibility,
  };
}
